export default __webpack_public_path__ + "static/media/Georgie 9781408330647.4f06c052.jpg";